import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var WebhooksService = /** @class */ (function () {
    function WebhooksService(http) {
        this.http = http;
    }
    WebhooksService.prototype.getAll = function () {
        return this.http.get('/webhook/subscriptions');
    };
    WebhooksService.prototype.getTypes = function () {
        return this.http.get('/webhook/types');
    };
    WebhooksService.prototype.saveWebhook = function (webhook) {
        return this.http.post('/webhook/subscriptions', webhook);
    };
    WebhooksService.prototype.checkIfLimitsExceeded = function () {
        return this.http.get('/webhook/subscriptions/limits-exceeded');
    };
    WebhooksService.prototype.getSingle = function (id) {
        return this.http.get("/webhook/subscriptions/" + id);
    };
    WebhooksService.prototype.update = function (id, webhook) {
        return this.http.put("/webhook/subscriptions/" + id, webhook);
    };
    WebhooksService.prototype.activate = function (id) {
        return this.http.put("/webhook/subscriptions/" + id + "/activate", {});
    };
    WebhooksService.prototype.deactivate = function (id) {
        return this.http.put("/webhook/subscriptions/" + id + "/deactivate", {});
    };
    WebhooksService.prototype.delete = function (id) {
        return this.http.delete("/webhook/subscriptions/" + id);
    };
    WebhooksService.ngInjectableDef = i0.defineInjectable({ factory: function WebhooksService_Factory() { return new WebhooksService(i0.inject(i1.HttpClient)); }, token: WebhooksService, providedIn: "root" });
    return WebhooksService;
}());
export { WebhooksService };
